module.exports = __webpack_public_path__ + "img/partner_program.2573ac89.png";